/**
 * Left Sidebar Navigation Component
 * Main navigation sidebar with links and about section.
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthenticationContext';
import { Home, User, LogIn, UserPlus, Shield, Bookmark, Compass, Settings, Trophy, BarChart2 } from 'lucide-react';
import AboutWriteFlowSection from '../about/AboutWriteFlowSection';
import './LeftSidebarNavigation.css';

const LeftSidebarNavigation = () => {
  const { token, user } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="left-sidebar">
      <div className="sidebar-content">
        <div className="sidebar-top">
          <div className="sidebar-logo">
            <Link to="/">
              <span className="sidebar-logo-full">WriteFlow</span>
              <span className="sidebar-logo-mark">W</span>
            </Link>
            <p className="sidebar-tagline">One prompt a day to get your writing flowing</p>
          </div>
          
          <nav className="sidebar-nav">
            <Link 
              to="/" 
              className={`nav-item ${isActive('/') ? 'active' : ''}`}
            >
              <span className="nav-icon"><Home size={20} /></span>
              <span className="nav-text">Home</span>
            </Link>
            
            <Link
              to="/feed"
              className={`nav-item ${isActive('/feed') ? 'active' : ''}`}
            >
              <span className="nav-icon"><Compass size={20} /></span>
              <span className="nav-text">Feed</span>
            </Link>

            <Link
              to="/contest"
              className={`nav-item ${isActive('/contest') ? 'active' : ''}`}
            >
              <span className="nav-icon"><Trophy size={20} /></span>
              <span className="nav-text">Contest</span>
            </Link>

            {token && (
              <Link
                to="/saved"
                className={`nav-item ${isActive('/saved') ? 'active' : ''}`}
              >
                <span className="nav-icon"><Bookmark size={20} /></span>
                <span className="nav-text">Saved</span>
              </Link>
            )}

            {token && (
              <Link
                to="/stats"
                className={`nav-item ${isActive('/stats') ? 'active' : ''}`}
              >
                <span className="nav-icon"><BarChart2 size={20} /></span>
                <span className="nav-text">Stats</span>
              </Link>
            )}

            {token && user && (
              <Link
                to={`/profile/${user.id}`}
                className={`nav-item ${isActive(`/profile/${user.id}`) ? 'active' : ''}`}
              >
                <span className="nav-icon"><User size={20} /></span>
                <span className="nav-text">Profile</span>
              </Link>
            )}
            
            {token && (
              <Link
                to="/settings"
                className={`nav-item ${isActive('/settings') ? 'active' : ''}`}
              >
                <span className="nav-icon"><Settings size={20} /></span>
                <span className="nav-text">Settings</span>
              </Link>
            )}

            {token && user?.isAdmin && (
              <Link
                to="/admin"
                className={`nav-item ${isActive('/admin') ? 'active' : ''}`}
              >
                <span className="nav-icon"><Shield size={20} /></span>
                <span className="nav-text">Admin</span>
              </Link>
            )}

            {!token && (
              <>
                <Link 
                  to="/login" 
                  className={`nav-item ${isActive('/login') ? 'active' : ''}`}
                >
                  <span className="nav-icon"><LogIn size={20} /></span>
                  <span className="nav-text">Login</span>
                </Link>
                <Link 
                  to="/register" 
                  className={`nav-item ${isActive('/register') ? 'active' : ''}`}
                >
                  <span className="nav-icon"><UserPlus size={20} /></span>
                  <span className="nav-text">Sign Up</span>
                </Link>
              </>
            )}
          </nav>
        </div>

        <div className="sidebar-bottom">
          <AboutWriteFlowSection />
        </div>
      </div>
    </div>
  );
};

export default LeftSidebarNavigation;
